import Vue from 'vue'

export const actions = {
    namespaced: true,
    state: {
        actions: []
    },
    actions: {
        addAction({ commit }, payload) {
            commit('addAction', payload);
        },
        setActionAnswer({ commit }, payload) {
            commit('setAction', payload);
        },
    },
    mutations: {
        addAction(state, payload) {
            Vue.set(state, 'actions', [...state.actions, payload]);
        },
        setAction(state, { id, answer }) {
            let actions = state.actions;
            let action = actions.find(a => a.id === id);
            action.answer = answer;
            action.state = 1;
            Vue.set(state, 'actions', actions);
        }
    },
    getters: {
        getActions: state => state.actions,
        getAction: state => actionId => {
            return state.actions.find(a => a.id === actionId)
        },
        getPendingAction: state => participantId => {
            let action = state.actions.find(a => a.state === 0 && a.user.id === participantId);
            return action ?? {};
        }
    }
}